import { AVMStage } from '@awayfl/swf-loader';
export function FlashUtilScript_getTimer(sec) {
    return Date.now() - AVMStage.runtimeStartTime;
}
